import { render } from "./guide1-mobile.vue?vue&type=template&id=1f2316f2"
const script = {}

import exportComponent from "/Users/sung-hojang/git-projects/jpworldpay-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__